import { Injectable } from '@angular/core';
import { AppConstants } from './app.constants';
import { Domain } from './domain.constants';
@Injectable()
export class ApiConstants {

  public baseUrl = this.domain.baseUrl;
  private sessionBaseUrl = this.baseUrl + '/auth';
  private reportServiceUrl = this.baseUrl + '/reports-service';
  public authUrl: any;


  constructor(public domain: Domain) {
    this.authUrl = {
      auth: {
        url: this.sessionBaseUrl + '/authenticate',
        method: 'POST'
      },
      resetPassword: {
        url: this.sessionBaseUrl + '/resetpassword',
        method: 'POST'
      },
      resetUserPassword: {
        url: AppConstants.getBaseUrl(),
        method: 'POST'
      },
      getStateToken: {
        url: AppConstants.getBaseUrl(),
        method: 'POST'
      },
      mfaStatus: {
        url: this.sessionBaseUrl + '/mfaStatus',
        method: 'GET'
      },
      validate: {
        url: this.sessionBaseUrl + '/validate',
        method: 'POST'
      },
      sendResetLink: {
        url: this.sessionBaseUrl + '/forgotpassword',
        method: 'POST'
      },
      generateOtp: {
        url: this.sessionBaseUrl + '/otp/generate',
        method: 'POST'
      },
      verifyOtp: {
        url: this.sessionBaseUrl + '/otp/verify',
        method: 'POST'
      },
      authenticateOkta: {
        url: this.sessionBaseUrl + '/authenticateOkta',
        method: 'GET'
      },
      getConfig: {
        url: this.sessionBaseUrl + '/config',
        method: 'GET'
      },
      getTenants: {
        url : this.baseUrl + '/admin/users/tenants',
        method : 'GET'
      },
      updateTenant: {
        url : this.sessionBaseUrl + '/token',
        method : 'POST'
      },
      getUserPreference : {
        url: this.baseUrl + '/admin/users/preferences',
        method: 'GET'
      },
      logout: {
        url: this.sessionBaseUrl + '/logout',
        method: 'POST'
      },
      oktaLogout: {
        url: AppConstants.getBaseUrl(),
        method: 'DELETE'
      },
      oktaRequestContext: {
        url: this.sessionBaseUrl + '/idp/relayState',
        method: 'GET'
      },
      scheduleDetails: {
        url: this.reportServiceUrl + '/maintenance/schedule',
        method: 'GET'
      }
    };
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/shared/constants/api.constants.ts